var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPlatformFees(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "38-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "037512-Analytics---monthly-sales-2",
    transform: "translate(-896.000000, -1188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy",
    transform: "translate(857.000000, 574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(30.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_platformFees",
    transform: "translate(9.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    fill: "#EFF6F2",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "bx-wallet-alt",
    transform: "translate(10.000000, 11.000000)",
    fill: "#2F665C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,0 L2.4,0 C1.0768,0 0,1.0768 0,2.4 L0,12 C0,13.3232 1.0768,14.4 2.4,14.4 L14.4,14.4 C15.2824,14.4 16,13.6824 16,12.8 L16,1.6 C16,0.7176 15.2824,0 14.4,0 Z M2.4,12.8 C1.9584,12.8 1.6,12.4408 1.6,12 L1.6,2.4 C1.6,1.9592 1.9584,1.6 2.4,1.6 L14.4,1.6 L14.4,4 L9.6,4 C8.7176,4 8,4.7176 8,5.6 L8,8.8 C8,9.6824 8.7176,10.4 9.6,10.4 L14.4008,10.4 L14.4008,12.8 L2.4,12.8 Z M14.4,5.6 L14.4,8.8 L9.6,8.8 L9.6,5.6 L14.4,5.6 Z",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlatformFees);
export default __webpack_public_path__ + "static/media/ic-platform-fees.7eb6ddc1601eeed80cb5bfdbb72eba5f.svg";
export { ForwardRef as ReactComponent };